export interface IconProps {
    size?: number;
    color?: string;
}
export const Lamp = ({size = 25, color= '#878686'}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1819 33C19.6631 33 19.2285 32.824 18.8781 32.472C18.5278 32.12 18.352 31.6849 18.3508 31.1666C18.3495 30.6484 18.5253 30.2133 18.8781 29.8613C19.2309 29.5093 19.6655 29.3333 20.1819 29.3333H31.1688C31.6877 29.3333 32.1229 29.5093 32.4745 29.8613C32.826 30.2133 33.0012 30.6484 33 31.1666C32.9988 31.6849 32.823 32.1206 32.4726 32.4738C32.1223 32.827 31.6877 33.0024 31.1688 33H20.1819ZM4.6629 11H11.0262V3.66666H7.86742L4.6629 11ZM25.6754 27.5C25.1566 27.5 24.722 27.324 24.3716 26.972C24.0212 26.62 23.8454 26.1849 23.8442 25.6666V9.16666C23.8442 8.64722 23.6684 8.21211 23.3169 7.86133C22.9653 7.51055 22.5307 7.33455 22.0131 7.33333H14.6885V12.8333C14.6885 13.3528 14.5127 13.7885 14.1611 14.1405C13.8095 14.4925 13.3749 14.6679 12.8573 14.6667H1.87039C1.19897 14.6667 0.680143 14.3917 0.313912 13.8417C-0.0523186 13.2917 -0.0980975 12.7111 0.176575 12.1L4.52556 2.2C4.83076 1.52778 5.28061 0.993055 5.87512 0.595833C6.46964 0.198611 7.13374 0 7.86742 0H11.0262C12.0333 0 12.8958 0.359333 13.6136 1.078C14.3314 1.79667 14.6897 2.65955 14.6885 3.66666H22.0131C23.539 3.66666 24.8361 4.20139 25.9043 5.27083C26.9724 6.34027 27.5065 7.63888 27.5065 9.16666V25.6666C27.5065 26.1861 27.3307 26.6218 26.9792 26.9738C26.6276 27.3258 26.193 27.5012 25.6754 27.5Z"
        fill={color}
      />
    </svg>
  );
};

export const Plug = ({size = 25, color= '#878686'}: IconProps) => {
  return (<svg width={size} height={size} viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M27.3585 8.44131C28.4528 9.53052 28.4528 11.3005 27.3585 12.2535L23.5283 16.0657L12.8585 5.44601L16.6887 1.6338C17.783 0.544601 19.5613 0.544601 20.5189 1.6338L22.9811 4.08451L27.0849 0L29 1.9061L24.8962 5.99061L27.3585 8.44131ZM19.4245 16.338L17.5094 14.4319L13.6792 18.2441L10.8066 15.385L14.6368 11.5728L12.7217 9.66667L8.89151 13.4789L6.83962 11.5728L3.00943 15.385C1.91509 16.4742 1.91509 18.2441 3.00943 19.1972L5.4717 21.6479L0 27.0939L1.91509 29L7.38679 23.554L9.84906 26.0047C10.9434 27.0939 12.7217 27.0939 13.6792 26.0047L17.5094 22.1925L15.5943 20.2864L19.4245 16.338Z" fill={color}/>
    </svg>
    )
}

export const ElectricPole = ({size = 25, color= '#878686'}: IconProps) => {
  return (<svg width={size} height={size+2} viewBox="0 0 35 37" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M17.5 2V35M2 6.95H33M3.55 3.65V6.95M9.75 3.65V6.95M25.25 3.65V6.95M31.45 3.65V6.95M28.35 6.95L17.5 18.5L6.65 6.95" stroke={color} stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    
    )
}

export const Human = ({size = 25, color= '#878686'}: IconProps) => {
  return (<svg width={size} height={size} viewBox="0 0 23 29" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.5 11.5C14.6756 11.5 17.25 8.92564 17.25 5.75C17.25 2.57436 14.6756 0 11.5 0C8.32436 0 5.75 2.57436 5.75 5.75C5.75 8.92564 8.32436 11.5 11.5 11.5Z" fill={color}/>
    <path d="M23 22.2812C23 25.8534 23 28.75 11.5 28.75C0 28.75 0 25.8534 0 22.2812C0 18.7091 5.14912 15.8125 11.5 15.8125C17.8509 15.8125 23 18.7091 23 22.2812Z" fill={color}/>
    </svg>
    
    )
}

export type iconNames = 'lamp' | 'plug' | 'electricPole' | 'humane';
export const getIcon = (iconName: iconNames, props?: IconProps) :  JSX.Element => {
    switch (iconName) {
        case 'lamp':
        return <Lamp {...props}/>;
        case 'plug':
        return <Plug {...props}/>;
        case 'electricPole':
        return <ElectricPole {...props}/>;
        case 'humane':
        return <Human {...props}/>;

        default:
        return <Lamp {...props}/>;
    }
}